import { Person } from '@/api/entities/people/types'
import { Subtask, SubtaskStatus } from '@/api/pathways/subtasks/types'
import { useNotificationStore } from '@/legacy/store/modules/notification'
import { NotificationType } from '@/legacy/types/notifications'
import { UUID } from '@/libs/typing/base'
import { usePointerSubtaskApi, usePointerSubtaskPersonApi } from './store'

/**
 * @param entityId
 */
export async function getPointerSubtasksForStaff(
  entityId: UUID
): Promise<Subtask[] | null> {
  const pointerSubtaskApi = usePointerSubtaskApi()
  try {
    const pointerSubtasks = await pointerSubtaskApi.list({
      params: {
        filter_staff_ids: [entityId],
        filter_pointer_comm_subtasks_only: true,
        page_length: 5,
        sort_by: ['dueDatetime,desc'],
        filter_subtask_status: [
          SubtaskStatus.OPEN_ASSIGNED,
          SubtaskStatus.IN_PROGRESS,
        ],
      },
    })
    return pointerSubtasks.data
  } catch (err) {
    useNotificationStore().setNotification({
      message: 'Error fetching pointer subtasks',
      type: NotificationType.WARNING,
      error: `Error fetching pointer subtasks: ${err}`,
    })
    return null
  }
}

/**
 * @param entityIds
 */
export async function getPeopleDataForPointerSubtasks(
  entityIds: UUID[]
): Promise<Person[] | null> {
  const personApi = usePointerSubtaskPersonApi()
  try {
    const people = await personApi.list({
      params: {
        filter_entity_ids: entityIds,
      },
    })
    return people.data
  } catch (err) {
    useNotificationStore().setNotification({
      message: 'Error fetching people data for pointer subtasks',
      type: NotificationType.WARNING,
      error: `Error fetching people data for pointer subtasks: ${err}`,
    })
    return null
  }
}
